module.exports = __webpack_public_path__ + "static/media/landing.a714b1be.jpg";